<template>
  <div class="Footer" :style="{'width': 1920*scaleBiLi + 'px','height':  540*scaleBiLi + 'px'}">
    <div class="wrap" :style="{'transform': 'scale(' + scaleBiLi + ')','transform-origin': 'center top'}">
      <div class="logoBar">
        <img class="logo" src="@/assets/images/Home66@2x.png" alt="">
	<div style="display: flex;align-items: flex-end;width: 270px;justify-content: space-between;">
	  <!-- <span id="_ideConac"></span> -->
          <img style="width:60px;cursor: pointer;" @click="toDanWei" src="@/assets/images/Home70@2x.png" alt="">
	  <img class="pic" src="@/assets/images/Home67@2x.png" alt="">
	</div>
      </div>
      <div class="menu">
        <div class="nav">
          <div class="item" v-if="item.url !='/Search' && !item.hidden && $store.getters.lang == 'zh'" v-for="(item,index) in $store.getters.menu" :key="index">
            <div class="first" :style="{'font-size':$store.getters.lang=='en'?'18px':''}">{{item.title}}</div>
            <router-link v-if="!item2.hidden" :style="{'font-size':$store.getters.lang=='en'?'16px':''}" :to="item2.url" tag="div" class="second" v-for="(item2,index2) in item.child" :key="item2.url">{{item2.title}}
            </router-link>
          </div>
          <div class="item" v-if="item.url !='/Search' && !item.hidden && $store.getters.lang == 'en'" v-for="(item,index) in $store.getters.menuEn" :key="index">
            <div class="first" :style="{'font-size':$store.getters.lang=='en'?'18px':''}">{{item.title}}</div>
            <router-link v-if="!item2.hidden" :style="{'font-size':$store.getters.lang=='en'?'16px':''}" :to="item2.url" tag="div" class="second" v-for="(item2,index2) in item.child" :key="item2.url">{{item2.title}}
            </router-link>
          </div>
        </div>
        <div class="siteinfo">
          <div class="tel">
            <p>0769-86119909</p>
            <span>{{$t('homeFooter.p1')}}</span>
          </div>
          <div class="wxCode">
            <div class="item">
              <img src="@/assets/images/Home68@2x.png" alt="">
              <span class="text-hide">{{$t('homeFooter.p2')}}</span>
            </div>
            <div class="item">
              <img src="@/assets/images/Home69@2x.png" alt="">
              <span class="text-hide">{{$t('homeFooter.p3')}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="copyright" :style="{'width': 1920*scaleBiLi + 'px','height':  58*scaleBiLi + 'px','line-height':  58*scaleBiLi + 'px'}">
      <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" :style="{'transform': 'scale(' + scaleBiLi + ')','transform-origin': 'center top'}">
        {{$t('homeFooter.p4')}}
      </a>
    </div>
  </div>
</template>




<script>
  import {getMenu,getMenuEn} from "@/api"

  export default {
    name: "Footer",
    watch:{
      '$store.getters.lang' : function(val) {
        // console.log('交不',val)
        if(val=='en'){
          this.$store.dispatch('GetMenuEn').then()
        }else{
          this.$store.dispatch('GetMenu').then()
        }
      }
    },
    data() {
      return {
        navArr: [],
        // 屏幕比例
        scaleBiLi: 1
      }
    },
    created() {

      // document.write(unescape("%3Cspan id='_ideConac' %3E%3C/span%3E%3Cscript  src='https://dcs.conac.cn/js/nis/44/19/00/602c594c0362c59fdd4196255b01a945/12441900751093869R-20024586.js' type='text/javascript'%3E%3C/script%3E"));

      // 计算屏幕比例
      this.$nextTick(() => {
        this.scaleBiLi = document.documentElement.clientWidth / 1920
        window.addEventListener('resize', () => {
          this.scaleBiLi = document.documentElement.clientWidth / 1920
        })
      })

      // 获取导航、内页大图
      if(this.$store.getters.lang == 'en'){
        this.$store.dispatch('GetMenuEn').then()
      }else{
        this.$store.dispatch('GetMenu').then()
      }

      // 获取轮播图
      this.$store.dispatch('GetBanner')
    },
    methods: {
	toDanWei(){
	 window.open('https://bszs.conac.cn/sitename?method=show&id=434A207D968F03ADE06310291AAC5129', '_blank');
	},
    }
  }
</script>

<!-- <style lang="less">
  #imgConac{
    width:60px;
  }
</style> -->

<style scoped lang="less"> 

  .Footer {
    width: 100%;
    height: 540px;
    background: #161616;

    .wrap {
      width: 1378px;
      height: 100%;
      margin: 0 auto;

      .logoBar {
        height: 195px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #505050;
      }

      .menu {
        width: 100%;
        display: flex;

        .nav {
          width: 1100px;
          display: flex;
          padding-top: 38px;

          /*.item + .item {*/
            /*margin-left: 47px;*/
          /*}*/

          /*.item:first-child {*/
            /*margin-left: 23px;*/
          /*}*/

          .item {
            text-align: center;
            flex: 0 0 134px;
            .first {
              cursor: pointer;
              font-family: SourceHanSans;
              font-weight: 400;
              font-size: 20px;
              color: #FFFFFF;
              line-height: 24px;
            }

            .second {
              cursor: pointer;
              margin-top: 18px;
              font-family: SourceHanSans;
              font-weight: 400;
              font-size: 18px;
              color: #888888;
              line-height: 24px;
              transition: .3s;
            }

            .second:hover {
              color: #fff;
            }
          }
        }

        .siteinfo {
          width: 278px;
          padding-top: 42px;

          .tel {
            width: 100%;
            border-left: 1px solid #CBCBCB;
            padding-left: 27px;

            p {
              height: 27px;
              font-family: DINCondensed;
              font-weight: bold;
              font-size: 27px;
              color: #FEFEFE;
              line-height: 24px;
            }

            span {
              font-family: SIL;
              font-size: 16px;
              color: #BEBEBE;
              line-height: 24px;
              margin-top: 4px;
              display: inline-block;
            }
          }

          .wxCode {
            width: 100%;
            display: flex;
            margin-top: 41px;
            margin-left: 27px;

            .item + .item {
              margin-left: 40px;
            }

            .item {
              width: 112px;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;

              img {
                width: 100px;
                height: 100px;
              }

              span {
                font-family: Source Han Sans CN;
                font-weight: 400;
                font-size: 16px;
                color: #FFFFFF;
                margin-top: 22px;
              }
            }
          }
        }
      }
    }

    .copyright {
      width: 100%;
      height: 58px;
      line-height: 58px;
      background: #080808;
      font-family: Source Han Sans CN;
      font-size: 16px;
      text-align: center;
      a{
        color:#CBCBCB;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/common/Footer.vue